const styles = (theme) => ({
  modalHeading: {
    color: theme.palette.common.darkBlue,
    fontSize: '20px',
  },
  modalIntroTest: {
    color: 'rgb(77, 114, 178)',
    fontSize: '14px',
  },
  surveyLink: {
    color: theme.palette.common.darkBlue,
    fontWeight: '600',
    fontStyle: 'italic',
    textDecoration: 'underline',
  },
  actionButton: {
    fontSize: '14px',
    '&:disabled': {
      backgroundColor: '#ccc',
      color: '#888',
      cursor: 'not-allowed',
      borderColor: '#ddd',
    },
  },
  closeButton: {
    backgroundColor: theme.palette.common.white,
    color: '#000000 !important',
    '&:hover': {
      backgroundColor: theme.palette.common.darkBlue,
    },
  },
  dialogContainerSize: {
    '& > div > div': {
      maxWidth: '950px',
    },
  },
  surveyDialogContainerSize: {
    '& > div > div': {
      maxWidth: '885px',
    },
  },
  surveyForm: {
    marginBottom: '28px',
    marginTop: '15px',
  },
  surveyQuestion: {
    color: '#444444',
    fontWeight: 'bold',
    lineHeight: '1.2',
    marginBottom: '5px',
  },
  radioLabel: {
    marginBottom: '-9px',
    marginTop: '0px',
  },
  checkBox: {
    color: theme.palette.common.darkBlue,
    padding: '0 5px 0',
    marginRight: '0',
    marginBottom: '0',
    fontSize: 25,
    '&:hover': {
      background: 'transparent',
    },
    '&$checked': {
      color: theme.palette.common.darkBlue,
      '&:hover': {
        background: 'transparent',
      },
    },
  },
  checked: {
    color: theme.palette.common.darkBlue,
  },
});

export default styles;
